import Link from "next/link"

const WhereToBuy = ({ setMenuactive }) => {
  return (
    <Link href="/where-to-buy" className="text-base "
      onClick={() => {
        setMenuactive(false)
      }}

    >Where to Buy</Link>
  )
}

export default WhereToBuy